import React from 'react';

const NotificationsAcceptedContext = React.createContext(false);

export default NotificationsAcceptedContext;